import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("bm_token");
    if (!token) { setUser(null); setAccount(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user); setAccount(data.account);
    } catch {
      localStorage.removeItem("bm_token");
      setUser(null); setAccount(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = (token, u) => {
    localStorage.setItem("bm_token", token);
    setUser(u);
    refresh();
  };

  const logout = () => {
    localStorage.removeItem("bm_token");
    setUser(null); setAccount(null);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, account, loading, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
